<script>
import Vue from 'vue'
import moment from 'moment'

export default {
  computed: {
    locale: function () {
      return Vue.i18n.locale()
    }
  },
  filters: {
    readableDate: function (date) {
      moment.locale(Vue.i18n.locale())
      return moment(date).from(moment())
    }
  }
}
</script>
